import {
    ENDPOINT_LOADING,
    ENDPOINT_LOADED,
    ENDPOINT_SEARCHED,
    ENDPOINT_CREATED,
    ENDPOINT_EDITED,
    ENDPOINT_DELETED,
    ENDPOINT_FAILED,
    LOGOUT,
} from '../types';

import {
    createPaginated,
    editPaginated,
    deletePaginated,
} from '../../helpers/reduxUtils';

const initialState = {
    loading: false,
    allEndpoints: null,
    searchResults: null,
    success: false,
    endpointTypes: [
        { value: '1', label: 'JSON' },
        { value: '0', label: 'HTTP POST' },
    ],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case ENDPOINT_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
            };
        case ENDPOINT_LOADED:
            return {
                ...state,
                succes: false,
                loading: false,
                allEndpoints: action.payload,
            };
        case ENDPOINT_SEARCHED:
            return {
                ...state,
                succes: false,
                loading: false,
                searchResults: action.payload,
            };
        case ENDPOINT_CREATED:
            return {
                ...state,
                succes: true,
                loading: false,
                allEndpoints: createPaginated(state.allEndpoints, action.payload),
            };
        case ENDPOINT_EDITED:
            return {
                ...state,
                succes: true,
                loading: false,
                allEndpoints: editPaginated(state.allEndpoints, action.payload),
            };
        case ENDPOINT_DELETED:
            return {
                ...state,
                success: true,
                loading: false,
                allEndpoints: deletePaginated(state.allEndpoints, action.payload),
            };
        case ENDPOINT_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
            };
        case LOGOUT:
            return {
                loading: false,
                allEndpoints: null,
                searchResults: null,
                success: false,
            };
        default:
            return state;
    }
}